const API_URL = "https://api-custom-pc-builder.thehustle.nz/api";
// const API_URL = "http://localhost:8083/api";
const apiGet = makeRequest("GET", { cache: false });
const apiPost = makeRequest("POST", {});
const config = window.shopifyApp;

console.log({ config });

let shop = null;
let currentStep = null;
let preferences = null;
let selectedPreferenceIds = [];
let games = [];
let selectedGamesIds = [];
let selectedGames = [];
let resolutions = [];
let selectedResolution = null;
let fpsType = "fpsPerformance"; // fpsPerformance | fpsVisualFidelity
let budget = 2500;
let cpus = [];
let selectedCPU = null;
let builds = [];
let selectedBuild = null;
let components = [];
let selectedIndicatorIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8 0.6875C6.55373 0.6875 5.13993 1.11637 3.9374 1.91988C2.73486 2.72339 1.7976 3.86544 1.24413 5.20163C0.690668 6.53781 0.545857 8.00811 0.828011 9.4266C1.11017 10.8451 1.80661 12.148 2.82928 13.1707C3.85196 14.1934 5.15492 14.8898 6.57341 15.172C7.99189 15.4541 9.46219 15.3093 10.7984 14.7559C12.1346 14.2024 13.2766 13.2651 14.0801 12.0626C14.8836 10.8601 15.3125 9.44628 15.3125 8C15.3105 6.06123 14.5394 4.20246 13.1685 2.83154C11.7975 1.46063 9.93877 0.689547 8 0.6875ZM11.2105 6.71047L7.27297 10.648C7.22073 10.7003 7.15869 10.7418 7.09041 10.7701C7.02212 10.7984 6.94892 10.8129 6.875 10.8129C6.80108 10.8129 6.72789 10.7984 6.6596 10.7701C6.59131 10.7418 6.52928 10.7003 6.47703 10.648L4.78953 8.96047C4.68399 8.85492 4.62469 8.71177 4.62469 8.5625C4.62469 8.41323 4.68399 8.27008 4.78953 8.16453C4.89508 8.05898 5.03824 7.99969 5.1875 7.99969C5.33677 7.99969 5.47992 8.05898 5.58547 8.16453L6.875 9.45477L10.4145 5.91453C10.4668 5.86227 10.5288 5.82081 10.5971 5.79253C10.6654 5.76424 10.7386 5.74969 10.8125 5.74969C10.8864 5.74969 10.9596 5.76424 11.0279 5.79253C11.0962 5.82081 11.1582 5.86227 11.2105 5.91453C11.2627 5.96679 11.3042 6.02884 11.3325 6.09712C11.3608 6.1654 11.3753 6.23859 11.3753 6.3125C11.3753 6.38641 11.3608 6.4596 11.3325 6.52788C11.3042 6.59616 11.2627 6.65821 11.2105 6.71047Z" fill="#CC9C70"/>
                            </svg>`;

function makeRequest(method, defaults = {}) {
  const isGet = method.toUpperCase() === "GET";

  return function (url, data = {}, options = {}) {
    const apiUrl = API_URL + url;
    const settings = $.extend(
      true,
      {
        url: apiUrl,
        type: method,
        dataType: "json",
        processData: isGet,
        contentType: isGet
          ? "application/x-www-form-urlencoded; charset=UTF-8"
          : "application/json; charset=UTF-8",
        data: isGet ? data : JSON.stringify(data),
      },
      defaults,
      options
    );

    return $.ajax(settings);
  };
}

/**
 * Renders or removes a “grid” skeleton in the given container.
 *
 * @param {string} targetSelector  jQuery selector for the container
 * @param {string} itemClass       Tailwind classes for each skeleton item
 * @param {boolean} show           true to render skeleton, false to clear it
 */
function renderGridSkeleton(
  targetSelector,
  cellClasses,
  count = 10,
  show = true
) {
  const $container = $(targetSelector);

  if (show) {
    const delayStep = 100; // ms between each item’s pulse start

    $container.empty();

    for (let i = 0; i < count; i++) {
      const delay = i * delayStep;
      const $cell = $(`
        <div class="${cellClasses} animate-pulse"
             style="animation-delay: ${delay}ms;">
          <div class="w-full h-full bg-gray-100 rounded-md"></div>
        </div>
      `);
      $container.append($cell);
    }
  } else {
    $container.empty();
  }
}

function buttonLoad(
  button,
  show = false,
  customClass = "bg-charcoal/60 cursor-not-allowed flex items-center justify-between"
) {
  if (!button.data("original-text")) {
    button.data("original-text", button.text().trim());
  }
  const originalText = button.data("original-text");

  if (show) {
    button
      .prop("disabled", true)
      .addClass(customClass)
      .removeClass("bg-charcoal cursor-pointer");
    button.html(`${originalText} <svg
      xmlns="http://www.w3.org/2000/svg"
      class="animate-spin h-5 w-5 text-white ml-2"
      viewBox="0 0 50 50"
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        opacity="0.25"
      />
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        stroke-dasharray="41.89 83.78"
        stroke-opacity="0.75"
      />
    </svg>`);
  } else {
    button
      .prop("disabled", false)
      .removeClass(
        "bg-charcoal/60 cursor-not-allowed flex items-center justify-between"
      )
      .addClass("bg-charcoal cursor-pointer");
    button.html(originalText);
  }
}

function formatPrice(price, locale = "en-US", currency = "NZD") {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(price);
}

function scrollToTop(targetSelector, duration = 400, offset = 0) {
  const $target = $(targetSelector);
  if (!$target.length) return; // nothing to scroll to

  const topPos = $target.first().offset().top + offset;

  $("html, body").stop().animate({ scrollTop: topPos }, duration);
}

function initializeAccordion() {
  $("#accordion").on("click", ".accordion-item > button", function () {
    const $btn = $(this);
    const $svg = $btn.find("svg");
    const target = $($btn.data("target"));

    // close any open panels
    $("#accordion .accordion-item > div:visible")
      .slideUp(300)
      .prev("button")
      .find("svg")
      .removeClass("rotate-180");

    // toggle this panel
    if (target.is(":visible")) {
      target.removeClass("border-b").slideUp(300);
      $svg.removeClass("rotate-180");
    } else {
      target.addClass("border-b").slideDown(300);
      $svg.addClass("rotate-180");
    }
  });
}

function setRangeBubble() {
  const range = document.getElementById("minmax-range");
  const bubble = document.getElementById("range-bubble");
  if (!range || !bubble) return;

  const min = Number(range.min);
  const max = Number(range.max);
  const val = Number(range.value);

  const percent = ((val - min) / (max - min)) * 100;

  bubble.textContent = `$${val}`;

  bubble.style.left = `calc(${percent}% )`;

  budget = val;
}

function getShop(config) {
  apiGet("/shop", { shop: config.domain })
    .done((response) => {
      shop = response;

      console.log({ shop });

      if (shop) {
        getGamePreferences(shop.id, {
          perPage: "50",
          sortBy: "display_order",
          sortDirection: "asc",
          relations: "games",
        });
      }
    })
    .fail((jqXHR, status, err) => {
      console.error("GET failed:", status, err);
    });
}

function swapPreviewImage(selector, newSrc, duration = 300) {
  const $container = $(selector);
  const $oldImg = $container.find("img");

  const lockedHeight = $container.height();
  $container.css("min-height", lockedHeight);

  $oldImg.stop(true).fadeOut(duration);

  const img = new Image();
  img.src = newSrc;

  $(img).on("load", function () {
    $oldImg.remove();
    $(img)
      .css({ display: "none", width: "100%", height: "auto" })
      .appendTo($container)
      .fadeIn(duration, function () {
        $container.css("min-height", "");
      });
  });

  setTimeout(() => {
    $container.css("min-height", "");
  }, duration * 3);
}

function getGamePreferences(id, params) {
  renderGridSkeleton(
    ".preference-box-wrapper",
    "w-1/5 h-60 px-3 mb-6 flex flex-col",
    10,
    true
  );
  apiGet(`/shop/${id}/game-preference`, params)
    .done((response) => {
      const { data } = response;

      if ((data || []).length > 0) {
        const htmlWrapper = $(".preference-box-wrapper");
        htmlWrapper.empty();

        preferences = data;

        data.forEach((preference) => {
          const $card = $(`
              <div class="w-full sm:w-4/12 md:w-1/5 px-3 mb-6 flex flex-col">
                  <div class="preference-item relative flex-1 pt-12 pb-10 px-3 border border-black
                              transition-all duration-300 hover:border-sand
                              cursor-pointer" data-preference-id="${preference.id}">

                    <div class="selection-indicator hidden absolute top-2 right-2">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 0.6875C6.55373 0.6875 5.13993 1.11637 3.9374 1.91988C2.73486 2.72339 1.7976 3.86544 1.24413 5.20163C0.690668 6.53781 0.545857 8.00811 0.828011 9.4266C1.11017 10.8451 1.80661 12.148 2.82928 13.1707C3.85196 14.1934 5.15492 14.8898 6.57341 15.172C7.99189 15.4541 9.46219 15.3093 10.7984 14.7559C12.1346 14.2024 13.2766 13.2651 14.0801 12.0626C14.8836 10.8601 15.3125 9.44628 15.3125 8C15.3105 6.06123 14.5394 4.20246 13.1685 2.83154C11.7975 1.46063 9.93877 0.689547 8 0.6875ZM11.2105 6.71047L7.27297 10.648C7.22073 10.7003 7.15869 10.7418 7.09041 10.7701C7.02212 10.7984 6.94892 10.8129 6.875 10.8129C6.80108 10.8129 6.72789 10.7984 6.6596 10.7701C6.59131 10.7418 6.52928 10.7003 6.47703 10.648L4.78953 8.96047C4.68399 8.85492 4.62469 8.71177 4.62469 8.5625C4.62469 8.41323 4.68399 8.27008 4.78953 8.16453C4.89508 8.05898 5.03824 7.99969 5.1875 7.99969C5.33677 7.99969 5.47992 8.05898 5.58547 8.16453L6.875 9.45477L10.4145 5.91453C10.4668 5.86227 10.5288 5.82081 10.5971 5.79253C10.6654 5.76424 10.7386 5.74969 10.8125 5.74969C10.8864 5.74969 10.9596 5.76424 11.0279 5.79253C11.0962 5.82081 11.1582 5.86227 11.2105 5.91453C11.2627 5.96679 11.3042 6.02884 11.3325 6.09712C11.3608 6.1654 11.3753 6.23859 11.3753 6.3125C11.3753 6.38641 11.3608 6.4596 11.3325 6.52788C11.3042 6.59616 11.2627 6.65821 11.2105 6.71047Z" fill="#CC9C70"/>
                        </svg>
                    </div>
                    <div class="icon-wrapper flex justify-center mb-6">
                        <img src="${preference.icon}" alt="${preference.label} icon"
                            class="w-[50px] h-[50px] object-cover"/>
                    </div>
                    <div class="icon-text text-center font-semibold px-6 whitespace-normal break-normal">
                        ${preference.label}
                    </div>
                  </div>
              </div>
              `);

          htmlWrapper.append($card);
        });
      }
    })
    .fail((jqXHR, status, err) => {
      console.error("GET failed:", status, err);
    });
}

function getGamesFromSelectedPreference(stepFrom = null) {
  const selectedPreferences = preferences
    ? preferences.filter((pref) => selectedPreferenceIds.includes(pref.id))
    : [];

  const consolidatedGames = Object.values(
    selectedPreferences
      .flatMap((pref) => pref.games || [])
      .reduce((acc, game) => ((acc[game.id] = game), acc), {})
  );

  const isFromValidStep = stepFrom ? [1].includes(stepFrom) : null;

  if (consolidatedGames.length > 0) {
    games = consolidatedGames;

    renderGridSkeleton(
      ".games-box-wrapper",
      "w-4/12 h-[230px] px-3 mb-8 flex flex-col",
      6,
      true
    );

    setTimeout(() => {
      const htmlWrapper = $(".games-box-wrapper");
      htmlWrapper.empty();

      consolidatedGames.forEach((game) => {
        let $card = null;
        if (isFromValidStep) {
          $card = $(`
              <div class="w-4/12 px-3 mb-8 flex flex-col">
                  <div class="game-item relative flex-1
                              transition-all duration-300 
                                border-transparent
                              cursor-pointer border hover:shadow-sand" data-game-id="${game.id}">
                    <div class="selection-indicator hidden absolute top-2 right-2">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 0.6875C6.55373 0.6875 5.13993 1.11637 3.9374 1.91988C2.73486 2.72339 1.7976 3.86544 1.24413 5.20163C0.690668 6.53781 0.545857 8.00811 0.828011 9.4266C1.11017 10.8451 1.80661 12.148 2.82928 13.1707C3.85196 14.1934 5.15492 14.8898 6.57341 15.172C7.99189 15.4541 9.46219 15.3093 10.7984 14.7559C12.1346 14.2024 13.2766 13.2651 14.0801 12.0626C14.8836 10.8601 15.3125 9.44628 15.3125 8C15.3105 6.06123 14.5394 4.20246 13.1685 2.83154C11.7975 1.46063 9.93877 0.689547 8 0.6875ZM11.2105 6.71047L7.27297 10.648C7.22073 10.7003 7.15869 10.7418 7.09041 10.7701C7.02212 10.7984 6.94892 10.8129 6.875 10.8129C6.80108 10.8129 6.72789 10.7984 6.6596 10.7701C6.59131 10.7418 6.52928 10.7003 6.47703 10.648L4.78953 8.96047C4.68399 8.85492 4.62469 8.71177 4.62469 8.5625C4.62469 8.41323 4.68399 8.27008 4.78953 8.16453C4.89508 8.05898 5.03824 7.99969 5.1875 7.99969C5.33677 7.99969 5.47992 8.05898 5.58547 8.16453L6.875 9.45477L10.4145 5.91453C10.4668 5.86227 10.5288 5.82081 10.5971 5.79253C10.6654 5.76424 10.7386 5.74969 10.8125 5.74969C10.8864 5.74969 10.9596 5.76424 11.0279 5.79253C11.0962 5.82081 11.1582 5.86227 11.2105 5.91453C11.2627 5.96679 11.3042 6.02884 11.3325 6.09712C11.3608 6.1654 11.3753 6.23859 11.3753 6.3125C11.3753 6.38641 11.3608 6.4596 11.3325 6.52788C11.3042 6.59616 11.2627 6.65821 11.2105 6.71047Z" fill="#CC9C70"/>
                        </svg>
                    </div>
                    <div class="image-wrapper flex justify-center">
                        <img src="${game.image}" alt="${game.label} icon"
                            class="w-full object-cover"/>
                    </div>
                  </div>
              </div>
              `);
        } else {
          $card = $(`
              <div class="w-4/12 px-3 mb-8 flex flex-col">
                  <div class="game-item relative flex-1
                              transition-all duration-300 
                                ${selectedGamesIds.includes(game.id) ? "selected border-sand shadow-sand" : "border-transparent disabled border-gray-300 text-gray-400 cursor-not-allowed"}
                              cursor-pointer border  hover:shadow-sand" data-game-id="${game.id}">
                    <div class="selection-indicator ${selectedGamesIds.includes(game.id) ? "" : "hidden"}  absolute top-2 right-2">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 0.6875C6.55373 0.6875 5.13993 1.11637 3.9374 1.91988C2.73486 2.72339 1.7976 3.86544 1.24413 5.20163C0.690668 6.53781 0.545857 8.00811 0.828011 9.4266C1.11017 10.8451 1.80661 12.148 2.82928 13.1707C3.85196 14.1934 5.15492 14.8898 6.57341 15.172C7.99189 15.4541 9.46219 15.3093 10.7984 14.7559C12.1346 14.2024 13.2766 13.2651 14.0801 12.0626C14.8836 10.8601 15.3125 9.44628 15.3125 8C15.3105 6.06123 14.5394 4.20246 13.1685 2.83154C11.7975 1.46063 9.93877 0.689547 8 0.6875ZM11.2105 6.71047L7.27297 10.648C7.22073 10.7003 7.15869 10.7418 7.09041 10.7701C7.02212 10.7984 6.94892 10.8129 6.875 10.8129C6.80108 10.8129 6.72789 10.7984 6.6596 10.7701C6.59131 10.7418 6.52928 10.7003 6.47703 10.648L4.78953 8.96047C4.68399 8.85492 4.62469 8.71177 4.62469 8.5625C4.62469 8.41323 4.68399 8.27008 4.78953 8.16453C4.89508 8.05898 5.03824 7.99969 5.1875 7.99969C5.33677 7.99969 5.47992 8.05898 5.58547 8.16453L6.875 9.45477L10.4145 5.91453C10.4668 5.86227 10.5288 5.82081 10.5971 5.79253C10.6654 5.76424 10.7386 5.74969 10.8125 5.74969C10.8864 5.74969 10.9596 5.76424 11.0279 5.79253C11.0962 5.82081 11.1582 5.86227 11.2105 5.91453C11.2627 5.96679 11.3042 6.02884 11.3325 6.09712C11.3608 6.1654 11.3753 6.23859 11.3753 6.3125C11.3753 6.38641 11.3608 6.4596 11.3325 6.52788C11.3042 6.59616 11.2627 6.65821 11.2105 6.71047Z" fill="#CC9C70"/>
                        </svg>
                    </div>
                    <div class="image-wrapper flex justify-center">
                        <img src="${game.image}" alt="${game.label} icon"
                            class="w-full object-cover ${selectedGamesIds.includes(game.id) || selectedGamesIds.length < 3 ? "" : "grayscale opacity-50"}"/>
                    </div>
                  </div>
              </div>
              `);
        }

        htmlWrapper.append($card);
      });
    }, 700);
  }
}

function getResolutions(id, params) {
  renderGridSkeleton(
    ".resolutions-tab",
    "w-1/3 h-[30px] px-3 mb-6 flex flex-col",
    3,
    true
  );
  apiGet(`/shop/${id}/game-settings`, params)
    .done((response) => {
      const { data } = response;

      if ((data || []).length > 0) {
        const htmlWrapper = $(".resolutions-tab");
        htmlWrapper.empty();

        resolutions = data;
        selectedResolution = data[0];
        fpsType = "fpsPerformance";
        data[0].selected = true;

        data.forEach((resolution) => {
          const $card = $(`
            <div class="w-full flex justify-center">
              <div class="
                resolution-item
                flex
                border
                cursor-pointer
                ${resolution.selected ? "border-[#BC8E35] bg-[#EFEBE4]" : "border-black bg-white"}
                hover:border-[#BC8E35]
                hover:bg-[#EFEBE4]
                min-w-[150px]
                h-[50px]
                items-center
                justify-center" data-resolution-id="${resolution.id}">
                ${resolution.value.label}
              </div>
            </div>
              `);

          htmlWrapper.append($card);
        });

        selectedGames = games.filter((game) =>
          selectedGamesIds.includes(game.id)
        );

        $("#fpsToggle").prop("checked", false);

        renderResolutionGames(
          $(".selected-games-wrapper"),
          selectedResolution || {}
        );
      }
    })
    .fail((jqXHR, status, err) => {
      console.error("GET failed:", status, err);
    });
}

function getCPUs(id, params) {
  renderGridSkeleton(
    ".cpu-box-wrapper",
    "w-1/2 h-[500px] px-3 mb-6 flex flex-col",
    2,
    true
  );
  apiGet(`/shop/${id}/game-settings`, params)
    .done((response) => {
      const { data } = response;

      if ((data || []).length > 0) {
        const htmlWrapper = $(".cpu-box-wrapper");
        htmlWrapper.empty();

        cpus = data;

        data.forEach((cpu) => {
          const $card = $(`
            <div class="w-full md:w-1/2 flex justify-center">
              <div class="
                relative
                cpu-item
                w-full
                mx-2
                text-center
                p-4
               " data-cpu-id="${cpu.id}" style="border: 1px solid ${cpu.value.color}">
                <div class="cpu-logo mt-12 mb-6">
                    <img src="${cpu.value.image || ""}" class="w-[150px] mx-auto" />
                </div>
                <div class="cpu-heading mb-6">
                    <h2 class="font-opensans font-extrabold text-2xl mb-2">${cpu.value.label}</h2>
                    <p class="text-sm">${cpu.value.subheading}</p>
                </div>
                <div class="cpu-description-heading mb-2">
                    <p class="font-bold text-xs uppercase">${cpu.value.descriptionHeading}</p>
                </div>
                <div class="cpu-description-content leading-6 text-center text-xs mb-32 whitespace-pre-line">
                    ${cpu.value.descriptionContent}
                </div>
                <button type="button"   
                    class="
                    button-cpu-selection
                    absolute
                    left-1/2
                    -translate-x-1/2
                    bottom-4
                    w-[calc(100%-32px)]
                    uppercase px-10 py-4 font-semibold text-sm rounded-lg text-white border-none
                    ${
                      (cpu.value.customBuildIds || []).length === 0
                        ? "disabled cursor-not-allowed"
                        : ""
                    }
                    "
                    ${
                      (cpu.value.customBuildIds || []).length === 0
                        ? "disabled"
                        : ""
                    }
                    data-cpu-id="${cpu.id}"
                    data-step="4"
                    style="
                      background-color: ${cpu.value.color || "#CC9C70"};
                      ${
                        (cpu.value.customBuildIds || []).length === 0
                          ? "opacity: 0.2;  "
                          : ""
                      }
                    ">CUSTOMIZE</button>
              </div>
            </div>
              `);

          htmlWrapper.append($card);
        });
      }
    })
    .fail((jqXHR, status, err) => {
      console.error("GET failed:", status, err);
    });
}

function getBuildCalculatedPrice(build) {
  let buildTotalPrice = 0;

  (build.value.components || []).forEach((component) => {
    const { products } = component;
    const selectedProducts = (products || []).filter(
      (product) => product.selected
    );

    selectedProducts.forEach(
      (product) =>
        (buildTotalPrice +=
          parseFloat(product.price) * parseInt(product.quantity))
    );
  });

  return formatPrice(buildTotalPrice || 0);
}

function generateTotalPriceUpdate() {
  builds = builds.map((build) => ({
    ...build,
    total: getBuildCalculatedPrice(build),
  }));
}

function getBuilds(id, params) {
  // renderGridSkeleton(
  //   "#accordion,
  //   "w-1/2 h-[500px] px-3 mb-6 flex flex-col",
  //   2,
  //   true
  // );
  apiGet(`/shop/${id}/game-settings`, params)
    .done((response) => {
      const { data } = response;

      builds = (data || [])
        .map((build, index) => {
          return {
            ...build,
            selected: index === 0,
            value: {
              ...build.value,
              components: (build.value.components || []).map((component) => {
                return {
                  ...component,
                  products: (component.products || []).map((product) => {
                    return {
                      ...product,
                      selected: product.isDefault,
                    };
                  }),
                };
              }),
            },
          };
        })
        .filter((build) =>
          (selectedCPU.value.customBuildIds || []).includes(build.id)
        );

      generateTotalPriceUpdate();

      selectedBuild = (builds || []).find((build) => build.selected);
      renderBuildComponents();
      renderSpecsBuildListItem();
      displayBuildSpecsPreviewGroup();
    })
    .fail((jqXHR, status, err) => {
      console.error("GET failed:", status, err);
    });
}

function renderBuildComponents() {
  // Render Components section
  const htmlWrapper = $("#accordion");
  htmlWrapper.empty();
  if (selectedBuild) {
    (selectedBuild.value.components || []).forEach((component, index) => {
      const { products } = component;

      const defaultProduct = products.find((product) => product.selected);

      let accordionContent = ``;

      products.forEach((product, index) => {
        accordionContent += `
                    <div class="product-item-wrapper shrink-0 w-full md:w-1/2 lg:w-1/4 px-1 mb-2">
                      <div class="product-item product-item-${product.id} build-item-product-${selectedBuild.id} component-group-${component.id} cursor-pointer h-full flex items-stretch flex-col overflow-hidden border ${product.selected ? "border-sand" : "border-[#F8F8F8]"} hover:border-sand flex-col group" data-build-id="${selectedBuild.id}" data-product-id="${product.id}" data-component-id="${component.id}">
                        <div class="product-image-wrapper flex w-full items-center justify-center">
                          <img src="${product.image}" alt="">
                        </div>
                        <div class="product-details bg-[#F8F8F8] flex flex-col justify-between gap-4 flex-1 p-4 relative">
                          <span class="text-charcoal text-xs md:text-sm font-semibold mb-6">${product.name}</span>
                          <span class="text-charcoal pricing-wrapper text-xs md:text-sm font-semibold flex items-center justify-between w-full">
                            ${formatPrice(product.price)}
                            ${product.selected ? selectedIndicatorIcon : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                  `;
      });

      const accordionItems = `
                  <div class="accordion-item">
                    <button
                      class="w-full flex justify-between items-center px-4 py-5 focus:outline-none !border-t-0 !border-l-0 !border-r-0  !border-b !border-[#D9D9D9]"
                      data-target="#panel-${selectedBuild.id}-${index}"
                    >
                      <!-- Icon and Label -->
                      <div class="flex items-center gap-4">
                        <div class="icon-wrapper">
                          <img src="${component.image}" alt="${component.componentName}">
                        </div>
                        <span class="text-left font-bold text-base text-charcoal">${component.componentName}</span>
                      </div>
      
                      <div class="flex items-center gap-4">
                        <!-- Selected Product Label -->
                        <span class="font-bold text-[10px] text-sand">${defaultProduct?.name || ""}</span>
                        <svg
                          class="w-5 h-5 transform transition-transform duration-300"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 9l-7 7-7-7" />
                        </svg>
                        </div>
                    </button>
      
                    <!-- Accordion Content -->
                    <div id="panel-${selectedBuild.id}-${index}" class="hidden px-2 py-4">
                      <div class="flex flex-wrap">
                        ${accordionContent}
                      </div>
                    </div>
                  </div>`;

      htmlWrapper.append(accordionItems);
    });
  }
}

function renderSpecsPreview() {
  // Update Specs Preview
  componentDisplay = (selectedBuild.value.components || []).find(
    (component) => component.id === selectedBuild.value.primaryComponentId
  );
  displayProduct = (componentDisplay.products || []).find(
    (product) => product.selected
  );

  swapPreviewImage(
    ".specs-item-preview-image",
    displayProduct.image || config.imagePlaceholder,
    400
  );

  displayBuildSpecsPreviewGroup();
}

function renderSpecsBuildListItem() {
  // Render Builds section
  const buildsWrapper = $(".custom-builds-wrapper");
  buildsWrapper.empty();

  if (builds.length > 0) {
    builds.forEach((buildItem, index) => {
      const { components } = buildItem.value || [];
      const displayBuildComponent = (components || []).find(
        (component) => component.id === buildItem.value?.primaryComponentId
      );

      if (displayBuildComponent) {
        const selectedProductFromThisComponent = (
          displayBuildComponent.products || []
        ).find((product) => product.selected);
        const buildHtmlItem = `
          <div
            class="specs-item specs-item-${buildItem.id} border border-b-0  last:border-b last:border-[#D9D9D9] flex items-stretch p-6 ${buildItem.selected ? "!border-sand !shadow !border-b" : "border-[#D9D9D9]"}"
          >
            <div
              class="image-wrapper w-[140px] flex items-center justify-center h-full flex-shrink-0"
            >
              <img
                src="${selectedProductFromThisComponent.image}"
                loading="lazy"
                class="h-full object-contain"
              />
            </div>
            <div class="specs-details w-full flex flex-col justify-between flex-1">
              <h4 class="font-opensans font-semibold text-base">
                ${selectedProductFromThisComponent.name}
              </h4>
              <div class="price-action flex items-center gap-4 justify-between">
                <span class="font-opensans font-semibold text-base">${buildItem.total}</span>
                <button
                  type="button"
                  data-build-id="${buildItem.id}"
                  class="review-specs-btn bg-charcoal text-white min-w-[124px] uppercase tracking-wider px-6 py-2 rounded-lg transition-all duration-300 font-opensans font-semibold text-xs"
                >
                  Review Specs
                </button>
              </div>
            </div>
          </div>
        `;
        buildsWrapper.append(buildHtmlItem);
      }
    });

    // Render Specs Preview
    renderSpecsPreview();
  }
}

function displayBuildSpecsPreviewGroup() {
  // Get components names and display selected products
  const previewItemComponentGroup = $(".preview-item-group");
  let componentElement = ``;
  (selectedBuild.value.components || []).forEach((component) => {
    const { componentName, products } = component;
    const productChosen =
      (products || []).find((product) => product.selected) || {};

    componentElement += `
      <div class="preview-item flex items-start">
        <div class="px-4 item-label shrink-0 w-[150px] font-bold text-xs">
          ${componentName || "-"}
        </div>
        <div
          class="px-2 item-value w-full flex flex-wrap gap-2 justify-end text-[#949494] text-[10px]"
        >
          ${productChosen.name || "-"}
        </div>
      </div>
    `;
  });
  previewItemComponentGroup.html(componentElement);

  let gameTypeSelectionBadges = ``;
  const selectedPreferences = preferences
    ? preferences.filter((pref) => selectedPreferenceIds.includes(pref.id))
    : [];
  selectedPreferences.forEach((selected) => {
    gameTypeSelectionBadges += `
      <span class="border border-[#D9D9D9] bg-[#F8F8F8] rounded-full px-3 py-1">
        ${selected.label}
      </span>`;
  });
  $(".selected-games-badge-wrapper").html(gameTypeSelectionBadges);

  // Update Price
  $(".price-value").html(selectedBuild.total);

  // end: Update Specs Preview
}

function renderResolutionGames(
  wrapper,
  selectedResolution,
  fpsType = "fpsPerformance"
) {
  const gameHtmlWrapper = wrapper;
  const { value } = selectedResolution || {};
  const { games: resolutionGames = [] } = value || {};

  renderGridSkeleton(
    ".selected-games-wrapper",
    "w-4/12 h-[285px] px-3 mb-8 flex flex-col",
    3,
    true
  );

  setTimeout(() => {
    gameHtmlWrapper.empty();

    selectedGames.forEach((game) => {
      let fps = null;
      if (resolutionGames.length > 0) {
        const currentGame =
          resolutionGames.find((g) => g.id === game.id) ?? null;
        if (currentGame) {
          fps = {
            fpsPerformance: currentGame.fpsPerformance,
            fpsVisualFidelity: currentGame.fpsVisualFidelity,
          };
        }
      }
      const $gameCard = $(`
              <div class="w-4/12 px-3 mb-8 flex flex-col">
                  <div class="game-item relative flex-1
                              transition-all duration-300 
                              border-sand shadow-sand
                              cursor-pointer border border-transparent hover:shadow-sand" data-game-id="${game.id}">
                    <div class="selection-indicator hidden absolute top-2 right-2">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 0.6875C6.55373 0.6875 5.13993 1.11637 3.9374 1.91988C2.73486 2.72339 1.7976 3.86544 1.24413 5.20163C0.690668 6.53781 0.545857 8.00811 0.828011 9.4266C1.11017 10.8451 1.80661 12.148 2.82928 13.1707C3.85196 14.1934 5.15492 14.8898 6.57341 15.172C7.99189 15.4541 9.46219 15.3093 10.7984 14.7559C12.1346 14.2024 13.2766 13.2651 14.0801 12.0626C14.8836 10.8601 15.3125 9.44628 15.3125 8C15.3105 6.06123 14.5394 4.20246 13.1685 2.83154C11.7975 1.46063 9.93877 0.689547 8 0.6875ZM11.2105 6.71047L7.27297 10.648C7.22073 10.7003 7.15869 10.7418 7.09041 10.7701C7.02212 10.7984 6.94892 10.8129 6.875 10.8129C6.80108 10.8129 6.72789 10.7984 6.6596 10.7701C6.59131 10.7418 6.52928 10.7003 6.47703 10.648L4.78953 8.96047C4.68399 8.85492 4.62469 8.71177 4.62469 8.5625C4.62469 8.41323 4.68399 8.27008 4.78953 8.16453C4.89508 8.05898 5.03824 7.99969 5.1875 7.99969C5.33677 7.99969 5.47992 8.05898 5.58547 8.16453L6.875 9.45477L10.4145 5.91453C10.4668 5.86227 10.5288 5.82081 10.5971 5.79253C10.6654 5.76424 10.7386 5.74969 10.8125 5.74969C10.8864 5.74969 10.9596 5.76424 11.0279 5.79253C11.0962 5.82081 11.1582 5.86227 11.2105 5.91453C11.2627 5.96679 11.3042 6.02884 11.3325 6.09712C11.3608 6.1654 11.3753 6.23859 11.3753 6.3125C11.3753 6.38641 11.3608 6.4596 11.3325 6.52788C11.3042 6.59616 11.2627 6.65821 11.2105 6.71047Z" fill="#CC9C70"/>
                        </svg>
                    </div>
                    <div class="image-wrapper flex justify-center">
                        <img src="${game.image}" alt="${game.label} icon"
                            class="w-full object-cover"/>
                    </div>
                  </div>
                  <div class="fps-display-wrapper flex flex-col items-center justify-center mt-6">
                    <span class="label-fpsPerformance font-semibold text-charcoal text-lg ${fpsType === "fpsPerformance" ? "" : "hidden"}">${fps ? fps.fpsPerformance : "-"}</span>
                    <span class="label-fpsVisualFidelity font-semibold text-charcoal text-lg ${fpsType === "fpsVisualFidelity" ? "" : "hidden"}">${fps ? fps.fpsVisualFidelity : "-"}</span>
                    <div class="w-full h-1 mt-2 bg-gradient-to-r from-transparent via-[#CC9C70] to-transparent rounded-full"></div>
                  </div>
              </div>
              `);

      gameHtmlWrapper.append($gameCard);
    });
  }, 1000);
}

function setCurrentStep(stepSelector, currentStep) {
  scrollToTop("html");
  switch (stepSelector) {
    case "#step-2":
      if (currentStep == 1) {
        selectedGamesIds = [];
        selectedGames = [];
      }
      getGamesFromSelectedPreference(currentStep);
      break;
    case "#step-3":
      getResolutions(shop.id, {
        perPage: "10",
        sortBy: "displayOrder",
        sortDirection: "asc",
        key: "resolutions",
      });

      $("#minmax-range").val(budget);

      setRangeBubble();
      $("#minmax-range").on("input", setRangeBubble);
      break;
    case "#step-4":
      getCPUs(shop.id, {
        perPage: "10",
        sortBy: "displayOrder",
        sortDirection: "asc",
        key: "cpu",
      });
      break;
    case "#step-5":
      // get components and builds
      getBuilds(shop.id, {
        perPage: "25",
        sortBy: "created_at",
        sortDirection: "desc",
        key: "custom_builds",
        ids: [...new Set(selectedCPU.value.customBuildIds || [])].join(","),
      });
      break;
    default:
      break;
  }
}

$(document).ready(function () {
  $('[id^="step-"]').hide();
  $("#step-1").show();

  getShop(config);
  initializeAccordion();

  // on click preferences
  $(".preference-box-wrapper").on("click", ".preference-item", function () {
    const prefId = $(this).data("preference-id");
    const nextButton = $('button[data-step="1"]');

    if (selectedPreferenceIds.includes(prefId)) {
      // Always allow unselecting
      $(this).removeClass("selected border-sand").addClass("border-black");
      $(this).find(".selection-indicator").addClass("hidden");
      selectedPreferenceIds = selectedPreferenceIds.filter(
        (id) => id !== prefId
      );
    } else if (selectedPreferenceIds.length < 3) {
      // Only allow selecting if less than 3 are selected
      $(this).addClass("selected border-sand").removeClass("border-black");
      $(this).find(".selection-indicator").removeClass("hidden");
      selectedPreferenceIds.push(prefId);
    }

    if (selectedPreferenceIds.length >= 3) {
      $(".preference-item:not(.selected)").addClass(
        "disabled border-gray-300 text-gray-400 cursor-not-allowed"
      );
      $(".preference-item:not(.selected) img").addClass("grayscale opacity-50");
    } else {
      $(".preference-item").removeClass(
        "disabled border-gray-300 text-gray-400 cursor-not-allowed"
      );
      $(".preference-item img").removeClass("grayscale opacity-50");
    }

    if (selectedPreferenceIds.length === 0) {
      nextButton
        .prop("disabled", true)
        .addClass("bg-charcoal/60 cursor-not-allowed")
        .removeClass("bg-charcoal cursor-pointer");
    } else {
      nextButton
        .prop("disabled", false)
        .removeClass("bg-charcoal/60 cursor-not-allowed")
        .addClass("bg-charcoal cursor-pointer");
    }
  });

  // on click games
  $(".games-box-wrapper").on("click", ".game-item", function () {
    const gameId = $(this).data("game-id");
    const nextButton = $('button[data-step="2"]');

    if (selectedGamesIds.includes(gameId)) {
      $(this)
        .removeClass("selected border-sand shadow-sand")
        .addClass("border-transparent");
      $(this).find(".selection-indicator").addClass("hidden");
      selectedGamesIds = selectedGamesIds.filter((id) => id !== gameId);
    } else if (selectedGamesIds.length < 3) {
      $(this)
        .addClass("selected border-sand shadow-sand")
        .removeClass("border-transparent");
      $(this).find(".selection-indicator").removeClass("hidden");
      selectedGamesIds.push(gameId);
    }

    if (selectedGamesIds.length >= 3) {
      $(".game-item:not(.selected)").addClass(
        "disabled border-gray-300 text-gray-400 cursor-not-allowed"
      );
      $(".game-item:not(.selected) img").addClass("grayscale opacity-50");
    } else {
      $(".game-item").removeClass(
        "disabled border-gray-300 text-gray-400 cursor-not-allowed"
      );
      $(".game-item img").removeClass("grayscale opacity-50");
    }

    if (selectedGamesIds.length === 0) {
      nextButton
        .prop("disabled", true)
        .addClass("bg-charcoal/60 cursor-not-allowed")
        .removeClass("bg-charcoal cursor-pointer");
    } else {
      nextButton
        .prop("disabled", false)
        .removeClass("bg-charcoal/60 cursor-not-allowed")
        .addClass("bg-charcoal cursor-pointer");
    }
  });

  // on click resolutions
  $(".resolution-box-wrapper").on("click", ".resolution-item", function () {
    const resolutionId = $(this).data("resolution-id");

    selectedResolution = resolutionId;
    selectedResolution = resolutions.find(
      (resolution) => resolution.id == resolutionId
    );

    $(".resolution-item")
      .removeClass("border-[#BC8E35] bg-[#EFEBE4]")
      .addClass("border-black bg-white");
    $(this)
      .removeClass("border-black bg-white")
      .addClass("border-[#BC8E35] bg-[#EFEBE4]");

    // update FPS values
    renderResolutionGames(
      $(".selected-games-wrapper"),
      selectedResolution || {},
      fpsType
    );
  });

  $(".resolution-box-wrapper").on(
    "change",
    "input[type='checkbox']",
    function () {
      const isChecked = $(this).is(":checked");
      fpsType = isChecked ? "fpsVisualFidelity" : "fpsPerformance";
      console.log("Toggle changed:", fpsType, selectedResolution);

      if (fpsType === "fpsPerformance") {
        $(".label-fpsPerformance").show();
        $(".label-fpsVisualFidelity").hide();
      } else {
        $(".label-fpsVisualFidelity").show();
        $(".label-fpsPerformance").hide();
      }
    }
  );

  // Step Clicker
  $(".prev-next-button-wrapper").on("click", ".next-step", function () {
    const $btn = $(this);
    const toGoBack = $btn.data("back");
    const nextSelector = $btn.data("to-step");
    const $current = $btn.closest('[id^="step-"]');

    currentStep = $btn.data("step");
    setCurrentStep(nextSelector, currentStep);

    if (toGoBack) {
      $current.fadeOut(300, function () {
        $(nextSelector).fadeIn(300);
      });
      return;
    }

    buttonLoad($btn, true);

    setTimeout(() => {
      $current.fadeOut(300, function () {
        $(nextSelector).fadeIn(300, function () {
          buttonLoad($btn, false);
        });
      });
    }, 1000);
  });

  // on click cpu
  $(".cpu-box-wrapper").on("click", ".button-cpu-selection", function () {
    const $btn = $(this);
    const cpuId = $btn.data("cpu-id");
    const nextSelector = "#step-5";

    selectedCPU = (cpus || []).find((cpu) => cpu.id === cpuId);
    console.log({ cpus, selectedCPU, cpuId });

    if ((selectedCPU?.value?.customBuildIds || []).length === 0) {
      alert("This CPU has no build configuration.");

      return;
    }

    selectedBuild = (builds || []).find((build) => build.selected);

    currentStep = $btn.data("step");
    setCurrentStep(nextSelector, currentStep);

    buttonLoad(
      $btn,
      true,
      "bg-charcoal/60 cursor-not-allowed flex items-center justify-center gap-4"
    );

    // Find the current step container
    const $current = $btn.closest('[id^="step-"]');

    setTimeout(() => {
      $current.fadeOut(300, function () {
        $(nextSelector).fadeIn(300, function () {
          buttonLoad($btn, false);
        });
      });
    }, 1000);
  });

  // on click review build
  $(".parts-picker-box-wrapper").on("click", ".review-specs-btn", function () {
    const $btn = $(this);
    const buildId = $btn.data("build-id");
    const targetBuildItemElement = $(`.specs-item-${buildId}`);

    builds = builds.map((build, index) => {
      return {
        ...build,
        selected: build.id === buildId,
      };
    });

    selectedBuild = (builds || []).find((build) => build.selected);

    $(".specs-item")
      .removeClass("!border-sand !shadow !border-b")
      .addClass("border-[#D9D9D9]");

    targetBuildItemElement
      .removeClass("border-[#D9D9D9]")
      .addClass("!border-sand !shadow !border-b");

    renderBuildComponents();
    renderSpecsPreview();

    scrollToTop(".pc-builder-container");
  });

  // on click on product
  $(".parts-picker-box-wrapper").on("click", ".product-item", function () {
    const $btn = $(this);
    const buildId = $btn.data("build-id");
    const componentId = $btn.data("component-id");
    const productId = $btn.data("product-id");

    // Update builds
    // builds = (builds || []).map((build, index) => {
    //   return {
    //     ...build,
    //     value: {
    //       ...build.value,
    //       components: (build.value.components || []).map((component) => {
    //         if (build.id === buildId && component.id === componentId) {
    //           return {
    //             ...component,
    //             products: (component.products || []).map((product) => {
    //               const componentItems = $(`.component-group-${componentId}`);
    //               const productItem = $(`.product-item-${productId}`);

    //               componentItems
    //                 .removeClass("border-sand")
    //                 .addClass("border-[#F8F8F8]");
    //               componentItems.find("svg").remove();

    //               productItem
    //                 .addClass("border-sand")
    //                 .removeClass("border-[#F8F8F8]");

    //               productItem
    //                 .find(".pricing-wrapper")
    //                 .append(selectedIndicatorIcon);

    //               return {
    //                 ...product,
    //                 selected: parseInt(product.id) === parseInt(productId),
    //               };
    //             }),
    //           };
    //         }
    //         return {
    //           ...build,
    //         };
    //       }),
    //     },
    //   };
    // });

    // Update selected build
    selectedBuild = {
      ...selectedBuild,
      value: {
        ...selectedBuild.value,
        components: (selectedBuild.value?.components || []).map((component) => {
          if (component.id === componentId) {
            return {
              ...component,
              products: component.products.map((product) => {
                if (product.id === productId) {
                  const componentItems = $(`.component-group-${componentId}`);
                  const productItem = $(`.product-item-${productId}`);

                  componentItems
                    .removeClass("border-sand")
                    .addClass("border-[#F8F8F8]");
                  componentItems.find("svg").remove();

                  productItem
                    .addClass("border-sand")
                    .removeClass("border-[#F8F8F8]");

                  productItem
                    .find(".pricing-wrapper")
                    .append(selectedIndicatorIcon);
                }

                return product.id === productId
                  ? { ...product, selected: true }
                  : { ...product, selected: false };
              }),
            };
          }

          // 👇 VERY IMPORTANT: return the original component here
          return component;
        }),
      },
    };

    builds = builds.map((build) => {
      if (build.id === selectedBuild.id) {
        return selectedBuild;
      }

      return build;
    });

    selectedBuild.total = getBuildCalculatedPrice(selectedBuild);

    // Re-render build price
    generateTotalPriceUpdate();
    renderSpecsPreview();
  });

  // on click add-to-cart
  $(".parts-picker-box-wrapper").on("click", "#add-to-cart", function () {
    const $btn = $(this);
    const selectedProducts = (selectedBuild.value.components || []).reduce(
      (acc, component) => {
        const selected = (component.products || []).filter(
          (product) => product.selected
        );
        return [...acc, ...selected];
      },
      []
    );

    const payload = selectedProducts.map((product) => {
      return {
        id: product.shopifyVariantId,
        quantity: product.quantity || 1,
      };
    });

    buttonLoad($btn, true);

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({ items: payload }),
      contentType: "application/json",
      dataType: "json",
    })
      .done((cart) => {
        console.log("Added to cart:", cart);
        // redirect to cart page
        window.location.href = "/cart";
      })
      .fail((err) => {
        console.error("Failed to add:", err);
        buttonLoad($btn, false);
        alert("Oops—couldn’t add those items.");
      });
  });
});
